<template>
  <div>
    <download-excel
      style="width: 100px"
      :fetch="startDownload"
      :fields="json_fields"
      type="xls"
      name="拼团订单图表.xls"
    >
      <a-button type="primary" :style="{ margin: '0 0 24px 0' }"
        >导出Excel</a-button
      >
    </download-excel>
    <a-modal
      v-model="visible"
      title="砍价成员"
      centered
      width="1000px"
      okText="确定"
    >
      <a-table
        :columns="columnstwo"
        :row-key="(record) => record.userid"
        :data-source="datatwo"
        :loading="loading"
      >
        <template slot="pic3" slot-scope="text">
          <img class="img1" :src="text" alt="" />
        </template>
      </a-table>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :scroll="{ x: 2000, y: 500 }"
    >
      <!-- 头像 -->
      <template slot="pic" slot-scope="text">
        <img class="img1" :src="text" alt="" />
      </template>
      <!-- 商品图片 -->
      <template slot="pic2" slot-scope="text">
        <img class="img2" :src="text" alt="" />
      </template>
      <!-- 拼团状态 -->
      <template slot="sty" slot-scope="text">
        <p class="tx">
          {{
            text == true ? "拼团成功" : text == false ? "拼团失败" : "拼团中"
          }}
        </p>
      </template>
      <template slot="name" slot-scope="name">
        {{ name.first }} {{ name.last }}
      </template>
      <!-- <a-avatar slot="avatar" icon="user" /> -->
      <a-switch slot="memberStatus" default-checked @change="onChange" />
      <template slot="operate" slot-scope="text, operate">
        <a href="javascript:;" @click="getMembers(operate)">参团成员</a>
        <a
          href=""
          v-on:click.prevent="
            topage(
              `/home/groupOrderTwo/groupOrderDetailsTwo?orderNo=${operate.orderNo}`,
              operate.orderNo
            )
          "
          >订单详情</a
        >
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  groupOrderList,
  groupOrderListMmber,
  groupOrderListSeach,
} from "@/api/storeApi.js";

const columns = [
  {
    title: "编号",
    dataIndex: "orderNo",
    scopedSlots: { customRender: "orderNo" },
  },
  {
    title: "商品名称",
    dataIndex: "goodsInfo",
    // filters: [
    //   { text: "Male", value: "male" },
    //   { text: "Female", value: "female" },
    // ],
  },
  {
    title: "商品图片",
    dataIndex: "goodsImg",
    width: 150,
    align: "center",
    scopedSlots: { customRender: "pic2" },
  },
  {
    title: "拼团状态",
    dataIndex: "ptSuccess",
    align: "center",
    scopedSlots: { customRender: "sty" },
  },
  {
    title: "用户头像",
    dataIndex: "userHeadImg",
    align: "center",
    width: 150,
    scopedSlots: { customRender: "pic" },
  },
  {
    title: "用户uid",
    dataIndex: "userUid",
    // scopedSlots: { customRender: "memberStatus" },
  },
  {
    title: "拼团时长",
    dataIndex: "name",
    scopedSlots: { customRender: "" },
  },
  {
    title: "拼团折扣",
    dataIndex: "ptDiscount",
    scopedSlots: { customRender: "" },
  },
  {
    title: "成团人数",
    dataIndex: "ptPeoples",
    align: "center",
    scopedSlots: { customRender: "" },
  },
  {
    title: "相差人数",
    dataIndex: "ptRemaining",
    align: "center",
    scopedSlots: { customRender: "" },
  },
  {
    title: "订单状态",
    dataIndex: "orderStatusStr",
    scopedSlots: { customRender: "" },
  },
  {
    title: "组团时间",
    dataIndex: "ptTimeLong",
    scopedSlots: { customRender: "" },
  },
  {
    title: "拼团结束时间",
    dataIndex: "endTime",
    scopedSlots: { customRender: "" },
  },
  {
    title: "操作",
    dataIndex: "operate",
    fixed: "right",
    width: 250,
    scopedSlots: { customRender: "operate" },
  },
];
const columnstwo = [
  {
    title: "订单编号",
    dataIndex: "orderNo",
    align: "center",
    width: 120,
    scopedSlots: { customRender: "orderNo" },
  },
  {
    title: "用户uid",
    dataIndex: "userUid",
    align: "center",
    width: 120,
    scopedSlots: { customRender: "userUid" },
  },
  {
    title: "用户头像",
    dataIndex: "userHeadImg",
    align: "center",
    ellipsis: true,
    width: 120,
    scopedSlots: { customRender: "pic3" },
  },
  {
    title: "用户手机号码",
    dataIndex: "phone",
    sorter: true,
    align: "center",
    width: 140,
    scopedSlots: { customRender: "phone" },
  },

  {
    title: "参团时间",
    dataIndex: "createTime",
    align: "center",
    width: 150,
    scopedSlots: { customRender: "createTime" },
  },
];
export default {
  data() {
    return {
      data: [],
      data1: [],
      datatwo: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
      columnstwo,
    };
  },
  mounted() {
    // this.fetch();
    this.groupList();
  },
  props: ["formInline"],
  methods: {
    async startDownload(){
      // 构建查询参数，使用当前的筛选条件
      const userUid = this.formInline.userUid;
      const orderNo = this.formInline.orderNo;
      const endTime = this.formInline.endTime;
      const createTime = this.formInline.createTime;
      
      // 第一步：获取总数量，判断数据规模
      const countRes = await groupOrderListSeach(1, 1, userUid, orderNo, endTime, createTime);
      const totalCount = countRes.count || 0;
      
      if (totalCount === 0) {
        this.$message.warning('当前筛选条件下没有数据可导出');
        return [];
      }
      
      // 第二步：根据数据量决定获取策略
      let allData = [];
      
      if (totalCount <= 1000) {
        // 数据量较小，一次性获取
        const res = await groupOrderListSeach(totalCount, 1, userUid, orderNo, endTime, createTime);
        allData = res.data || [];
      } else {
        // 数据量较大，分页获取
        const pageSize = 100;
        const totalPages = Math.ceil(totalCount / pageSize);
        
        // 提示用户正在获取数据
        const loadingMsg = this.$message.loading(`正在获取数据... 0/${totalPages}页`, 0);
        
        try {
          for (let page = 1; page <= totalPages; page++) {
            const res = await groupOrderListSeach(pageSize, page, userUid, orderNo, endTime, createTime);
            if (res.data && res.data.length > 0) {
              allData = allData.concat(res.data);
            }
            // 更新进度提示
            loadingMsg();
            this.$message.loading(`正在获取数据... ${page}/${totalPages}页`, 0);
          }
        } finally {
          loadingMsg();
        }
      }
      
      this.$message.success(`成功获取 ${allData.length} 条数据，开始导出...`);
      return allData;
    },
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      // groupOrderList(10, this.pagination.current).then((res) => {
      //   this.data = res.data;
      //   console.log(res);
      // });
      groupOrderListSeach(
        this.formInline.limit,
        this.pagination.current,
        this.formInline.userUid,
        this.formInline.orderNo,
        this.formInline.endTime,
        this.formInline.createTime
      ).then((res) => {
        this.data = res.data;
        this.loading = false;
        this.pagination.total = res.count;
      });
      this.loading = false;
    },
    //
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    query() {
      this.pagination.current = 1;
      this.loading = true;
      groupOrderListSeach(
        this.formInline.limit,
        1,
        this.formInline.userUid,
        this.formInline.orderNo,
        this.formInline.endTime,
        this.formInline.createTime
      ).then((res) => {
        this.data = res.data;
        this.loading = false;
        this.pagination.total = res.count;
      });
    },
    //
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
    // 获取拼团订单列表
    groupList() {
      groupOrderList(10, 1).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
        console.log(res);
      });
    },
    // 拼团成员
    getMembers(row) {
      console.log(row.orderNo);
      groupOrderListMmber(10, 1, row.orderNo).then((result) => {
        console.log(result);
        this.datatwo = result.data;
      });
      this.visible = true;
    },
  },
};
</script>
<style scoped>
.img1 {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.img2 {
  width: 100px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/groupOrderTwo/groupOrderContentTwo.vue